<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card :loading="isLoading">
      <v-card-title>Редактирование метрики</v-card-title>
      <v-card-text>
        <v-container>
          <metric-form
            v-model="form"
            :data="item"
            @submit="onCreate"
          />
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';
import MetricForm from './MetricForm.vue';

const createDefaultForm = () => ({
  name: null,
  happenedAt: null,
});

export default {
  name: 'metric-dialog',
  components: { MetricForm },
  mixins: [DialogBusMixin],
  data: () => ({
    dialog: false,
    form: createDefaultForm(),
    isLoading: false,
    item: null,
  }),
  watch: {
    dialog: 'updateModal',
  },
  methods: {
    ...mapActions('metrics', ['update', 'getList']),
    ...mapActions(['showNotify']),

    beforeOpen({ item }) {
      this.item = item;
    },

    async onCreate() {
      this.isLoading = true;

      try {
        await this.update(this.form);
        await this.getList();
        this.showNotify({ message: 'Группа успешно создана' });
        this.dialog = false;
      } catch (e) {
        this.showNotify({ type: 'error', message: 'При создании группы произошла ошибка. Обратитесь к администратору' });
      }

      this.isLoading = false;
    },

    async updateModal() {
      this.form = createDefaultForm();
    },
  },
};
</script>
